import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-wrap ep"
}
const _hoisted_2 = {
  key: 0,
  class: "ep-preview"
}
const _hoisted_3 = { class: "ep-layout" }
const _hoisted_4 = { class: "ep-main" }
const _hoisted_5 = { class: "ep-fmt-where" }
const _hoisted_6 = ["aria-pressed"]
const _hoisted_7 = { class: "ep-paper" }
const _hoisted_8 = {
  key: 0,
  class: "ep-steps mini"
}
const _hoisted_9 = { class: "ep-n" }
const _hoisted_10 = { class: "ep-mini-t" }
const _hoisted_11 = { class: "ep-tools" }
const _hoisted_12 = ["disabled", "aria-label", "onClick"]
const _hoisted_13 = ["disabled", "aria-label", "onClick"]
const _hoisted_14 = ["aria-label", "onClick"]
const _hoisted_15 = {
  key: 1,
  class: "ep-steps"
}
const _hoisted_16 = { class: "ep-ins" }
const _hoisted_17 = ["aria-label", "onClick"]
const _hoisted_18 = ["id", "onFocusin"]
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = ["disabled", "aria-label", "onClick"]
const _hoisted_21 = ["disabled", "aria-label", "onClick"]
const _hoisted_22 = ["aria-label", "onClick"]
const _hoisted_23 = ["onUpdate:modelValue", "aria-label", "onKeydown"]
const _hoisted_24 = { class: "ep-body" }
const _hoisted_25 = {
  key: 0,
  class: "ep-pics"
}
const _hoisted_26 = {
  key: 0,
  class: "ep-pic"
}
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "ep-chips" }
const _hoisted_30 = ["onChange"]
const _hoisted_31 = {
  key: 1,
  class: "ep-chip ep-vid"
}
const _hoisted_32 = ["onUpdate:modelValue", "onInput"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["aria-pressed", "onClick"]
const _hoisted_35 = { viewBox: "0 0 24 24" }
const _hoisted_36 = ["d"]
const _hoisted_37 = {
  key: 0,
  class: "ep-empty"
}
const _hoisted_38 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor_bar = _resolveComponent("editor-bar")!
  const _component_editor_mode_toggle = _resolveComponent("editor-mode-toggle")!
  const _component_playbook_view = _resolveComponent("playbook-view")!
  const _component_tip_tap_toolbar = _resolveComponent("tip-tap-toolbar")!
  const _component_editor_doc_head = _resolveComponent("editor-doc-head")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_tip_tap = _resolveComponent("tip-tap")!
  const _component_editor_activity = _resolveComponent("editor-activity")!
  const _component_editor_details_drawer = _resolveComponent("editor-details-drawer")!
  const _component_editor_save_dialog = _resolveComponent("editor-save-dialog")!
  const _component_editor_discard_dialog = _resolveComponent("editor-discard-dialog")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_ai_improve_panel = _resolveComponent("ai-improve-panel")!

  return (_ctx.isLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_editor_bar, {
          name: _ctx.node.Name,
          version: _ctx.node.Version,
          dirty: _ctx.dirty,
          "type-label": "process",
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel())),
          onSave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSave())),
          onHeight: _cache[3] || (_cache[3] = ($event: any) => (_ctx.barHeight = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "ai-btn pb-btn",
              title: "Improve with AI",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAIEdit()))
            }, [...(_cache[27] || (_cache[27] = [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                class: "ep-fill"
              }, [
                _createElementVNode("path", { d: "M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z" })
              ], -1),
              _createElementVNode("span", null, "Improve with AI", -1)
            ]))])
          ]),
          _: 1
        }, 8, ["name", "version", "dirty"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
        }, [
          _createVNode(_component_editor_mode_toggle, {
            preview: _ctx.showPreview,
            "changed-count": _ctx.changedSteps.length,
            "changed-label": "steps",
            onEdit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closePreview())),
            onPreview: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openPreview()))
          }, null, 8, ["preview", "changed-count"]),
          (_ctx.showPreview)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_playbook_view, {
                  "preview-node": _ctx.previewNode,
                  "hide-bar": true,
                  "changed-steps": _ctx.changedSteps
                }, null, 8, ["preview-node", "changed-steps"])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["ep-fmt", { live: _ctx.activeEditor }]),
                style: _normalizeStyle({ top: _ctx.barHeight + 'px' })
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.activeEditor ? 'Step ' + (_ctx.activeIndex + 1) : 'Click into a step to format it'), 1),
                (_ctx.activeEditor)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "ep-fmt-btns",
                      onMousedown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.keepEditorFocus && _ctx.keepEditorFocus(...args)))
                    }, [
                      _createVNode(_component_tip_tap_toolbar, {
                        editor: _ctx.activeEditor,
                        "show-align": true
                      }, null, 8, ["editor"])
                    ], 32))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["ep-collapse ep-layout-toggle", { on: _ctx.node.ProcessLayout == 'grid' }]),
                  "aria-pressed": _ctx.node.ProcessLayout == 'grid',
                  title: "Show the steps as boxes, up to three to a row (see Preview)",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.node.ProcessLayout = _ctx.node.ProcessLayout == 'grid' ? null : 'grid'))
                }, [
                  _cache[28] || (_cache[28] = _createStaticVNode("<svg viewBox=\"0 0 24 24\"><rect x=\"3\" y=\"4\" width=\"7\" height=\"7\" rx=\"1\"></rect><rect x=\"14\" y=\"4\" width=\"7\" height=\"7\" rx=\"1\"></rect><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\" rx=\"1\"></rect><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\" rx=\"1\"></rect></svg>", 1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.node.ProcessLayout == 'grid' ? 'Grid layout: On' : 'Grid layout'), 1)
                ], 10, _hoisted_6),
                _createElementVNode("button", {
                  type: "button",
                  class: "ep-collapse",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleReorder()))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.reorder ? 'Show full steps' : 'Reorder steps') + " ", 1),
                  _cache[29] || (_cache[29] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                    _createElementVNode("path", { d: "M7 4v16M3 16l4 4 4-4M17 20V4M13 8l4-4 4 4" })
                  ], -1))
                ])
              ], 6),
              _createElementVNode("article", _hoisted_7, [
                _createVNode(_component_editor_doc_head, {
                  locs: _ctx.locs,
                  deps: _ctx.deps,
                  types: _ctx.types,
                  "owner-names": _ctx.ownerNames,
                  version: _ctx.node.Version,
                  onOpen: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDetails = true))
                }, null, 8, ["locs", "deps", "types", "owner-names", "version"]),
                (_ctx.reorder)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_draggable, {
                        modelValue: _ctx.processJSON.items,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.processJSON.items) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processJSON.items, (item, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: _ctx.keyOf(item),
                              class: "ep-mini"
                            }, [
                              _cache[33] || (_cache[33] = _createElementVNode("svg", {
                                class: "ep-grip",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("circle", {
                                  cx: "9",
                                  cy: "6",
                                  r: "1"
                                }),
                                _createElementVNode("circle", {
                                  cx: "15",
                                  cy: "6",
                                  r: "1"
                                }),
                                _createElementVNode("circle", {
                                  cx: "9",
                                  cy: "12",
                                  r: "1"
                                }),
                                _createElementVNode("circle", {
                                  cx: "15",
                                  cy: "12",
                                  r: "1"
                                }),
                                _createElementVNode("circle", {
                                  cx: "9",
                                  cy: "18",
                                  r: "1"
                                }),
                                _createElementVNode("circle", {
                                  cx: "15",
                                  cy: "18",
                                  r: "1"
                                })
                              ], -1)),
                              _createElementVNode("span", _hoisted_9, _toDisplayString(i + 1), 1),
                              _createElementVNode("span", _hoisted_10, _toDisplayString(item.header || 'Untitled step'), 1),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("button", {
                                  type: "button",
                                  disabled: i == 0,
                                  "aria-label": 'Move step ' + (i + 1) + ' up',
                                  onClick: ($event: any) => (_ctx.moveItem(i, -1))
                                }, [...(_cache[30] || (_cache[30] = [
                                  _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                    _createElementVNode("path", { d: "M6 15l6-6 6 6" })
                                  ], -1)
                                ]))], 8, _hoisted_12),
                                _createElementVNode("button", {
                                  type: "button",
                                  disabled: i == _ctx.processJSON.items.length - 1,
                                  "aria-label": 'Move step ' + (i + 1) + ' down',
                                  onClick: ($event: any) => (_ctx.moveItem(i, 1))
                                }, [...(_cache[31] || (_cache[31] = [
                                  _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                    _createElementVNode("path", { d: "M6 9l6 6 6-6" })
                                  ], -1)
                                ]))], 8, _hoisted_13),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "del",
                                  "aria-label": 'Delete step ' + (i + 1),
                                  onClick: ($event: any) => (_ctx.removeItem(i))
                                }, [...(_cache[32] || (_cache[32] = [
                                  _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                    _createElementVNode("path", { d: "M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3" })
                                  ], -1)
                                ]))], 8, _hoisted_14)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processJSON.items, (item, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: _ctx.keyOf(item)
                        }, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("button", {
                              type: "button",
                              "aria-label": 'Add a step before step ' + (i + 1),
                              onClick: ($event: any) => (_ctx.addItem(i))
                            }, [...(_cache[34] || (_cache[34] = [
                              _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                              ], -1),
                              _createTextVNode("Add step ", -1)
                            ]))], 8, _hoisted_17)
                          ]),
                          _createElementVNode("section", {
                            id: 'ep-step-' + i,
                            class: _normalizeClass(['ep-step', { noline: item.hideSectionLine }]),
                            onFocusin: ($event: any) => (_ctx.focusStep = i)
                          }, [
                            _createElementVNode("div", {
                              class: "ep-tools",
                              "aria-label": 'Step ' + (i + 1) + ' options'
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                disabled: i == 0,
                                "aria-label": 'Move step ' + (i + 1) + ' up',
                                onClick: ($event: any) => (_ctx.moveItem(i, -1))
                              }, [...(_cache[35] || (_cache[35] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M6 15l6-6 6 6" })
                                ], -1)
                              ]))], 8, _hoisted_20),
                              _createElementVNode("button", {
                                type: "button",
                                disabled: i == _ctx.processJSON.items.length - 1,
                                "aria-label": 'Move step ' + (i + 1) + ' down',
                                onClick: ($event: any) => (_ctx.moveItem(i, 1))
                              }, [...(_cache[36] || (_cache[36] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M6 9l6 6 6-6" })
                                ], -1)
                              ]))], 8, _hoisted_21),
                              _createElementVNode("button", {
                                type: "button",
                                class: "del",
                                "aria-label": 'Delete step ' + (i + 1),
                                onClick: ($event: any) => (_ctx.removeItem(i))
                              }, [...(_cache[37] || (_cache[37] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3" })
                                ], -1)
                              ]))], 8, _hoisted_22)
                            ], 8, _hoisted_19),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((item.header) = $event),
                              class: "ep-h",
                              placeholder: "Step title",
                              "aria-label": 'Step ' + (i + 1) + ' title',
                              onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.focusBody(i)), ["prevent"]), ["enter"])
                            }, null, 40, _hoisted_23), [
                              [_vModelText, item.header]
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_tip_tap, {
                                modelValue: item.body,
                                "onUpdate:modelValue": ($event: any) => ((item.body) = $event),
                                "hide-toolbar": true,
                                "show-align": true,
                                onFocus: ($event: any) => (_ctx.onEditorFocus($event, item))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus"])
                            ]),
                            (item.image || item.image2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['image', 'image2'], (slot) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: slot }, [
                                      (item[slot])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                            _createElementVNode("img", {
                                              src: item[slot],
                                              alt: 'Image for step ' + (i + 1)
                                            }, null, 8, _hoisted_27),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "ep-x",
                                              "aria-label": "Remove image",
                                              onClick: ($event: any) => (item[slot] = null)
                                            }, [...(_cache[38] || (_cache[38] = [
                                              _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                                _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
                                              ], -1)
                                            ]))], 8, _hoisted_28)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 64))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_29, [
                              (!item.image || !item.image2)
                                ? (_openBlock(), _createElementBlock("label", {
                                    key: 0,
                                    class: _normalizeClass(['ep-chip', { busy: _ctx.uploadingKey == _ctx.keyOf(item) }])
                                  }, [
                                    _createElementVNode("input", {
                                      type: "file",
                                      accept: "image/*",
                                      hidden: "",
                                      onChange: ($event: any) => (_ctx.onPickImage($event, item))
                                    }, null, 40, _hoisted_30),
                                    _cache[39] || (_cache[39] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                      _createElementVNode("path", { d: "M15 8h.01M12 21H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v6M3 16l5-5c.93-.9 2.07-.9 3 0l4 4M14 14l1-1c.67-.64 1.33-.84 2-.6M16 19h6M19 16v6" })
                                    ], -1)),
                                    _createTextVNode(_toDisplayString(_ctx.uploadingKey == _ctx.keyOf(item) ? 'Uploading…' : 'Image'), 1)
                                  ], 2))
                                : _createCommentVNode("", true),
                              (item.video || _ctx.videoOpenKey == _ctx.keyOf(item))
                                ? (_openBlock(), _createElementBlock("label", _hoisted_31, [
                                    _cache[40] || (_cache[40] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                      _createElementVNode("path", { d: "M15 10l4.55-2.28A1 1 0 0 1 21 8.62v6.76a1 1 0 0 1-1.45.9L15 14M5 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" })
                                    ], -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      ref_for: true,
                                      ref: 'video-' + _ctx.keyOf(item),
                                      "onUpdate:modelValue": ($event: any) => ((item.video) = $event),
                                      placeholder: "Paste a video link",
                                      onInput: ($event: any) => (_ctx.checkVideoLink(item))
                                    }, null, 40, _hoisted_32), [
                                      [_vModelText, item.video]
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "ep-chip",
                                    onClick: ($event: any) => (_ctx.openVideo(item))
                                  }, [...(_cache[41] || (_cache[41] = [
                                    _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                      _createElementVNode("path", { d: "M15 10l4.55-2.28A1 1 0 0 1 21 8.62v6.76a1 1 0 0 1-1.45.9L15 14M5 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zM9 10v4M7 12h4" })
                                    ], -1),
                                    _createTextVNode("Video ", -1)
                                  ]))], 8, _hoisted_33)),
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(['ep-chip', { on: item.hideSectionLine }]),
                                "aria-pressed": !!item.hideSectionLine,
                                onClick: ($event: any) => (item.hideSectionLine = !item.hideSectionLine)
                              }, [
                                (_openBlock(), _createElementBlock("svg", _hoisted_35, [
                                  _createElementVNode("path", {
                                    d: item.hideSectionLine ? 'M5 12h2M11 12h2M17 12h2' : 'M5 12h14'
                                  }, null, 8, _hoisted_36)
                                ])),
                                _createTextVNode(_toDisplayString(item.hideSectionLine ? 'Section line hidden' : 'Section line'), 1)
                              ], 10, _hoisted_34)
                            ])
                          ], 42, _hoisted_18)
                        ], 64))
                      }), 128)),
                      (!_ctx.processJSON.items.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_37, "No steps yet."))
                        : _createCommentVNode("", true)
                    ])),
                _createElementVNode("button", {
                  type: "button",
                  class: "ep-addlast",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addItem(_ctx.processJSON.items.length)))
                }, [...(_cache[42] || (_cache[42] = [
                  _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                    _createElementVNode("path", { d: "M12 5v14M5 12h14" })
                  ], -1),
                  _createTextVNode("Add step ", -1)
                ]))])
              ])
            ]),
            _createElementVNode("aside", {
              class: "ep-side",
              "aria-label": "Outline",
              style: _normalizeStyle({ top: _ctx.barHeight + 'px' })
            }, [
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "ep-side-h" }, "Outline", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processJSON.items, (item, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: _ctx.keyOf(item),
                  type: "button",
                  class: _normalizeClass(['ep-ol', { on: _ctx.focusStep == i }]),
                  onClick: ($event: any) => (_ctx.jumpTo(i))
                }, [
                  _createElementVNode("span", null, _toDisplayString(i + 1), 1),
                  _createTextVNode(_toDisplayString(item.header || 'Untitled step'), 1)
                ], 10, _hoisted_38))
              }), 128)),
              _createVNode(_component_editor_activity, {
                comments: _ctx.comments,
                "signed-count": _ctx.signedCount,
                "required-count": _ctx.requiredSigners.length,
                version: _ctx.node.Version
              }, null, 8, ["comments", "signed-count", "required-count", "version"])
            ], 4)
          ], 512), [
            [_vShow, !_ctx.showPreview]
          ])
        ], 2),
        (_ctx.showDetails)
          ? (_openBlock(), _createBlock(_component_editor_details_drawer, {
              key: 0,
              name: _ctx.node.Name,
              "onUpdate:name": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.node.Name) = $event)),
              ownerIds: _ctx.ownerIDs,
              "onUpdate:ownerIds": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ownerIDs) = $event)),
              locs: _ctx.locs,
              "onUpdate:locs": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.locs) = $event)),
              deps: _ctx.deps,
              "onUpdate:deps": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.deps) = $event)),
              types: _ctx.types,
              "onUpdate:types": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.types) = $event)),
              "type-label": "process",
              onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showDetails = false))
            }, null, 8, ["name", "ownerIds", "locs", "deps", "types"]))
          : _createCommentVNode("", true),
        (_ctx.showSave)
          ? (_openBlock(), _createBlock(_component_editor_save_dialog, {
              key: 1,
              status: _ctx.node.NeedsApprovalType,
              "onUpdate:status": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.node.NeedsApprovalType) = $event)),
              version: _ctx.node.Version,
              "required-count": _ctx.requiredSigners.length,
              "signed-count": _ctx.signedCount,
              busy: _ctx.disableButton,
              "note-placeholder": "e.g. Clarified when to hold the order in step 3",
              onCancel: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showSave = false)),
              onSave: _cache[20] || (_cache[20] = ($event: any) => (_ctx.submitCheck($event)))
            }, null, 8, ["status", "version", "required-count", "signed-count", "busy"]))
          : _createCommentVNode("", true),
        (_ctx.showDiscard)
          ? (_openBlock(), _createBlock(_component_editor_discard_dialog, {
              key: 2,
              onKeep: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showDiscard = false)),
              onDiscard: _cache[22] || (_cache[22] = ($event: any) => (_ctx.leave()))
            }))
          : _createCommentVNode("", true),
        (_ctx.showAIConfirm)
          ? (_openBlock(), _createBlock(_component_confirm_delete, {
              key: 3,
              onConfirm: _cache[23] || (_cache[23] = ($event: any) => (_ctx.submit())),
              onCancel: _cache[24] || (_cache[24] = () => { _ctx.showAIConfirm = false; }),
              msg: _ctx.AIConfirmText
            }, null, 8, ["msg"]))
          : _createCommentVNode("", true),
        (_ctx.aiEditDraft)
          ? (_openBlock(), _createBlock(_component_ai_improve_panel, {
              key: 4,
              "node-type": "process",
              slug: _ctx.node.Slug,
              "current-draft": { name: _ctx.node.Name, items: _ctx.processJSON.items, changesSummary: [] },
              "preview-base-node": _ctx.currentPreviewNode(),
              onClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.aiEditDraft = null)),
              onApply: _cache[26] || (_cache[26] = d => { _ctx.onAIDraft(d); _ctx.aiEditDraft = _ctx.aiEditDraft || {} }),
              onAccept: _ctx.onAIDraft
            }, null, 8, ["slug", "current-draft", "preview-base-node", "onAccept"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}